import { Injectable, inject, signal, computed } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { ApiCallingService } from './api-calling.service';
import { ResponseUtilityService } from './response-utility.service';
import { ApiResponseModel } from '../models/api-response.models';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  readonly #http = inject(ApiCallingService);
  readonly #responseUtility = inject(ResponseUtilityService);
  readonly #currencyPipe = new CurrencyPipe('en-US');

  readonly #currencyCode = signal<string>('');

  readonly currencyCode = this.#currencyCode.asReadonly();

  readonly currencySymbol = computed(() => {
    const code = this.#currencyCode();
    return this.#getCurrencySymbol(code);
  });

  updateCurrencyFromSalesOffice(salesOfficeId: string): void {
    this.#http.getData('lookup', 'sales-offices', true).subscribe({
      next: (res: ApiResponseModel<any[]>) => {
        const data = this.#responseUtility.handleResponse(res, '', false) ?? [];
        const selectedOffice = data.find((office: any) => office.id === salesOfficeId);

        if (selectedOffice?.currencyCode) {
          this.#currencyCode.set(selectedOffice.currencyCode.toUpperCase());
        } else {
          this.#currencyCode.set('CAD');
        }
      },
      error: () => {
        this.#currencyCode.set('CAD');
      }
    });
  }

  #getCurrencySymbol(code: string): string {
    try {
      const formatted = this.#currencyPipe.transform(0, code, 'symbol', '1.0-0');
      return formatted?.replace(/[\d\s,.]/g, '').trim() || 'CA$';
    } catch {
      return 'CA$';
    }
  }

  formatCurrency(value: number | string | null | undefined, digitsInfo = '1.2-2', currencyCode?: string): string {
    if (value === null || value === undefined || value === '') return '';

    const numValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numValue)) return '';

    const code = currencyCode ? currencyCode.toUpperCase() : this.#currencyCode();
    return this.#currencyPipe.transform(numValue, code, 'symbol', digitsInfo) || '';
  }

  getCurrencySymbolFromCode(code: string | null | undefined): string {
    if (!code) return this.currencySymbol();
    return this.#getCurrencySymbol(code.toUpperCase());
  }
}
